import { render, staticRenderFns } from "./adminRole.vue?vue&type=template&id=450e0371&scoped=true"
import script from "./adminRole.vue?vue&type=script&lang=ts"
export * from "./adminRole.vue?vue&type=script&lang=ts"
import style0 from "./adminRole.vue?vue&type=style&index=0&id=450e0371&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e0371",
  null
  
)

export default component.exports